import { useState } from "react";
import ProgressBar from "../components/ProductUploadProgressBar";
import GeneralForm from "../components/ProductUploadGeneralForm";
import SpecificationForm from "../components/ProductUploadSpecificationForm";
import VariantForm from "../components/ProductUploadVariantForm";
import apiCall from "../helper/apiCall";
import { toast } from 'react-toastify';
const ProductUpload = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    general: {},
    specification: {},
    variant: {},
  });

  // Array defining the steps of the form.
  const steps = [
    { name: 'General', component: GeneralForm },
    { name: 'Specification', component: SpecificationForm },
    { name: 'Variant', component: VariantForm },
  ];

  // Function to handle the final form submission.
  const handleSubmit = async (variantData) => {
    // Merge the last step's data with the rest of the form data.
    const completeFormData = {
      ...formData.general,
      ...formData.specification,
      ...variantData,
    };

    console.log('Final data to be submitted:', completeFormData);
    try{
      const payload = {payload : completeFormData}
      const result = await apiCall('createProduct',payload);
      if(result.success){
        toast.success(result.message);
      }else{
        toast.error('Something went wrong');
      }
    }catch(error){
      alert('Error uploading product. Please try again.');
    }
    // Make an API call to your backend.
    // try {
    //   const response = await fetch('/api/products', { // Replace with your actual API endpoint
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(completeFormData),
    //   });

    //   if (!response.ok) {
    //     throw new Error('Failed to save product data.');
    //   }

    //   const result = await response.json();
    //   console.log('Product saved successfully:', result);

    //   // You can add logic here to redirect the user or show a success message.
    //   alert('Product uploaded successfully!');
    //   // Example: redirect to the product list page
    //   // window.location.href = '/products'; 

    // } catch (error) {
    //   console.error('Error submitting form:', error);
    //   alert('Error uploading product. Please try again.');
    // }
  };

  // Function to handle moving to the next step or submitting the form.
  const handleNext = (data) => {
    const isLastStep = currentStep === steps.length - 1;

    // Update the form data for the current step.
    setFormData((prevData) => ({
      ...prevData,
      [steps[currentStep].name.toLowerCase()]: data,
    }));

    if (isLastStep) {
      // If it's the last step, handle the final submission.
      // This is a crucial step to ensure the variant data is captured correctly.
      handleSubmit(data);
    } else {
      // Otherwise, move to the next step.
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  // Function to handle moving back to the previous step.
  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  // Renders the appropriate component based on the current step.
  const renderStep = () => {
    const StepComponent = steps[currentStep].component;
    const isLastStep = currentStep === steps.length - 1;

    return (
      <StepComponent
        allFormData={formData}
        formData={formData[steps[currentStep].name.toLowerCase()]}
        onNext={handleNext}
        onBack={handleBack}
        isLastStep={isLastStep}
      />
    );
  };

  return (
    <div className="bg-white mx-auto w-[1024px]">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Product Upload</h1>
      <ProgressBar currentStep={currentStep} steps={steps} />
      {renderStep()}
    </div>
  );
};

export default ProductUpload;